import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import { get } from 'lodash';
export var defaultItems = [];
export var defaultMinChars = 2;
export var defaultFreeformItem = {
  freeform: true
};
export function defaultStateReducer(_, _ref) {
  var changes = _ref.changes;
  return changes;
}
export function defaultItemToString(item) {
  return get(item, 'label', '');
}
export function defaultNormaliser(item) {
  return {
    id: item,
    label: item
  };
}
export function defaultGetItemId(item) {
  return get(item, 'id');
}
export function defaultFilter(item, _ref2) {
  var _context;

  var inputValue = _ref2.inputValue,
      _ref2$itemToString = _ref2.itemToString,
      itemToString = _ref2$itemToString === void 0 ? defaultItemToString : _ref2$itemToString;
  return _includesInstanceProperty(_context = itemToString(item).toLowerCase()).call(_context, inputValue.toLowerCase());
}